import clsx from "clsx";
import { Camera, CameraOff } from "lucide-react";
import { useDrag } from "react-dnd";

import type { Channel, Device } from "../../types";

interface Props {
  device: Device;
  channel: Channel;
}

export function ChannelNode({ device, channel }: Props) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "CHANNEL",
    item: { type: "CHANNEL", deviceId: device.id, channel: channel.channel_number },
    collect: (m) => ({ isDragging: m.isDragging() }),
  }), [device.id, channel.channel_number]);

  const Icon = channel.has_signal ? Camera : CameraOff;
  return (
    <div
      ref={drag as any}
      className={clsx(
        "flex items-center gap-1 px-2 py-1 hover:bg-line cursor-move text-xs",
        isDragging && "opacity-50",
      )}
    >
      <Icon size={12} className={channel.has_signal ? "text-text" : "text-muted"} />
      <span className="text-muted w-6">CH{channel.channel_number}</span>
      <span className="truncate">{channel.name || `Canal ${channel.channel_number}`}</span>
    </div>
  );
}
